// extracted by mini-css-extract-plugin
export default {"widgetWrapper":"BmXNp0aAu5TKHmZbvWmM"};